import type { AutoInvoiceSkip, ChargeCreated } from '../api/schemas';

/**
 * What the Cobrado card says when "Emitir factura al cobrar" was on and the
 * Factura did not come back with the Cobro. One quiet line, never an alarm:
 * the charge itself went through.
 */
export function autoInvoiceNote(skipped: AutoInvoiceSkip, canInvoice: boolean): string {
  if (skipped === 'no_fiscal_profile') return 'Sin factura: falta configurar los datos fiscales.';
  if (skipped === 'plan') return 'Sin factura: tu plan no incluye facturas.';
  return canInvoice
    ? 'La factura no salió. Puedes emitirla ahora.'
    : 'La factura no salió. Avísale a quien lleva las facturas.';
}

/**
 * The one line a payment form shows after saving, when the owner turned on
 * "Emitir factura al cobrar": the number the server issued, or why it did not.
 * Nothing when the switch is off (no invoice and no reason came back).
 */
export function invoiceOutcome(
  charge: Pick<ChargeCreated, 'invoice' | 'invoiceSkipped'> | null | undefined,
  canInvoice: boolean,
): string | undefined {
  if (!charge) return undefined;
  if (charge.invoice) return `Factura ${charge.invoice.displayNumber} emitida.`;
  return charge.invoiceSkipped ? autoInvoiceNote(charge.invoiceSkipped, canInvoice) : undefined;
}

/**
 * Whether the manual "Emitir factura" still makes sense: not when the Factura
 * already exists, and not when the same reason (no datos fiscales, the plan)
 * would refuse the button too. After a failed attempt it is the retry.
 */
export function offersManualInvoice(charge: Pick<ChargeCreated, 'invoice' | 'invoiceSkipped'>): boolean {
  if (charge.invoice) return false;
  return charge.invoiceSkipped === undefined || charge.invoiceSkipped === 'failed';
}
